import { render, staticRenderFns } from "./RegisterStart.vue?vue&type=template&id=a04fbdbe&scoped=true&"
import script from "./RegisterStart.vue?vue&type=script&lang=js&"
export * from "./RegisterStart.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStart.vue?vue&type=style&index=0&id=a04fbdbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04fbdbe",
  null
  
)

export default component.exports